import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col, Table, Button } from 'reactstrap';
import * as repairLogEntryActions from '../../actions/repairLogEntryActions';
import { loadLimitedUsers } from '../../actions/userActions';
import RepairLogEntry from './RepairLogEntry';
import moment from 'moment';

class RepairLogEntryPage extends Component {
  componentWillMount() {
    if (!this.props.users.length > 0) this.props.actions.loadLimitedUsers();
    let currentLogId = Number.parseInt(this.props.currentRepairLog.id, 10);
    this.props.actions.loadEntriesByLogId(currentLogId);
  }

  redirectToAddEntryPage = () => {
    this.props.history.push(
      '/repair-log/' + this.props.currentRepairLog.id + '/repair-log-entry'
    );
  };

  render() {
    const logDate = moment(this.props.currentRepairLog.logDate).format(
      'ddd, MMM Do YYYY'
    );
    const { logEntries, users, currentRepairLog } = this.props;
    return (
      <Container fluid={true}>
        <Row>
          <Col md={12}>
            <h1 className="text-center my-4">Repair Log for {logDate}</h1>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Button
              className="primary mb-2"
              onClick={this.redirectToAddEntryPage}
            >
              Add
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {logEntries.length > 0 ? (
              <Table>
                <thead>
                  <tr>
                    <th>Hours</th>
                    <th>Location</th>
                    <th>Description</th>
                    <th>Employee</th>
                  </tr>
                </thead>
                <tbody>
                  {logEntries.map((entry) => (
                    <RepairLogEntry
                      key={entry.id}
                      logEntry={{ ...entry }}
                      user={users.filter((u) => u.id === entry.userId)[0]}
                      currentRepairLog={currentRepairLog}
                    />
                  ))}
                </tbody>
              </Table>
            ) : (
              <h4 className="my-4">No entries found</h4>
            )}
          </Col>
        </Row>
      </Container>
    );
  }
}

RepairLogEntryPage.propTypes = {
  currentRepairLog: PropTypes.object,
  actions: PropTypes.object.isRequired,
};

function getRepairLogById(logs, id) {
  const log = logs.filter((log) => log.id === id);
  if (log) return log[0];
  return null;
}

function mapStateToProps(state, ownProps) {
  const id = ownProps.match.params.id;
  const logId = Number.parseInt(id, 10);

  let currentLog = {
    id: '',
    logDate: '',
    siteId: '',
  };

  if (logId && state.repairLogs.length > 0) {
    currentLog = getRepairLogById(state.repairLogs, logId);
  }

  return {
    currentRepairLog: currentLog,
    logEntries: state.repairLogEntries,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...repairLogEntryActions, loadLimitedUsers },
      dispatch
    ),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(RepairLogEntryPage)
);



// WEBPACK FOOTER //
// ./src/components/repair-log/RepairLogEntryPage.js